// Closepaws: apply selected engraving font to inputs
(function () {
  function applyFontFromRadio(radio) {   
    const wrap = radio.closest(".closepaws-fonts");
    if (!wrap) return;

    const targets = (wrap.getAttribute("data-font-targets") || "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const font = radio.getAttribute("data-font");
    if (!font) return;

    targets.forEach((id) => {
      const el = document.getElementById(id);
      if (el) el.style.fontFamily = font;
    });
  }

  // Apply on change (works even if product form loads dynamically)
  document.addEventListener("change", (e) => {
    const radio = e.target;
    if (!radio.matches('.closepaws-font input[type="radio"][data-font]')) return;
    applyFontFromRadio(radio);
  });

  // Apply default on initial page load
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll('.closepaws-font input[type="radio"][data-font]:checked')
      .forEach(applyFontFromRadio);
  });
})();
